module.exports = __webpack_public_path__ + "assets/6635d58eee495dca32b411c1df713b44.png";